import Glide from '@glidejs/glide';
import formatDateString from '../../../helpers/formatDate';

const adsComponents: NodeListOf<HTMLDivElement> = document.querySelectorAll('.adsComponent');

adsComponents.forEach(adsComponent => {
    if (adsComponent) {
        const daysContainer: NodeListOf<HTMLDivElement> = adsComponent.querySelectorAll('.adsComponent__days-current');
        const bulletsContainer: NodeListOf<HTMLDivElement> = adsComponent.querySelectorAll('.glide__bullets');
        const days: NodeListOf<HTMLDivElement> = adsComponent.querySelectorAll('.adsComponent__day');
        const dayNumbers: NodeListOf<HTMLParagraphElement> = adsComponent.querySelectorAll('.adsComponent__day-number');
        const dates: NodeListOf<HTMLSpanElement> = adsComponent.querySelectorAll('.adsComponent__card-text');
        const adsCarousels: NodeListOf<Element> = adsComponent.querySelectorAll('.adsComponent__carousel-inner');
        const direction: string = document.querySelector('html').getAttribute('dir');
        const adTabs: NodeListOf<HTMLButtonElement> = adsComponent.querySelectorAll('.adsComponent__tab');
        const adCarouselsContainer: NodeListOf<HTMLDivElement> = adsComponent.querySelectorAll('.adsComponent__carousel');
        let activeTab: number = 0;
        let activeDay: number = 0;

        if (adsCarousels.length > 0) {
            const adsCarouselsArray = Array.from(adsCarousels) || [];

            const generateBullets = (carousel: HTMLElement, num: number) => {
                var bulletCount = carousel.querySelectorAll('.adsComponent__card').length - num;
                var bulletWrapper = carousel.querySelector('.glide__bullets');

                for (let index = 0; index < bulletCount; index++) {
                    const button = document.createElement('button');
                    button.className = 'glide__bullet';
                    button.setAttribute('data-glide-dir', '=' + index);

                    bulletWrapper.appendChild(button);
                }
            };

            adsCarouselsArray.forEach((item: HTMLElement) => {
                const glideSettings = {
                    type: 'slider',
                    perView: 3,
                    gap: 24,
                    rewind: false,
                    bound: true,
                    direction: direction || 'ltr',
                    breakpoints: {
                        768: {
                            perView: 2.3,
                            gap: 16,
                        },
                        480: {
                            perView: 2.27,
                        },
                    },
                };

                const glide = new Glide(item, glideSettings);

                glide.mount();

                // remove extra bullets depending how many slides per view
                const width: number = window.innerWidth;
                let diff: number = 0;

                width > 768 ? (diff = 2) : (diff = 1);

                generateBullets(item, diff);

                glide.on('move.after', () => {
                    const bullets: NodeListOf<HTMLButtonElement> = item.querySelectorAll('.glide__bullet');
                    const currentIndex = glide.index;

                    if (bullets.length > 0) {
                        bullets.forEach((bullet, index) => {
                            bullet.classList.remove('glide__bullet--active');

                            bullet.addEventListener('click', (e) => {
                                glide.go(`=${index}`);
                            });
                        });

                        bullets[currentIndex].classList.add('glide__bullet--active');
                    }
                });
            });
        }

        const resetAll = () => {
            adCarouselsContainer.forEach((carousel) => carousel.classList.remove('adsComponent__carousel--active'));
            daysContainer.forEach((item) => item.classList.add('hidden'));
            adTabs.forEach((tab) => tab.classList.remove('adsComponent__tab--active'));
            days.forEach((day) => day.classList.remove('adsComponent__day--active'));
            bulletsContainer.forEach((item) => item.classList.remove('glide__bullets--active'));
        };

        const showActiveItems = (activeTab: number, activeDay: number) => {
            resetAll();
            adTabs[activeTab].classList.add('adsComponent__tab--active');
            if (activeTab === 1) {
                adCarouselsContainer[activeDay].classList.add('adsComponent__carousel--active');
                bulletsContainer[activeDay].classList.add('glide__bullets--active');
            } else {
                daysContainer[activeTab].classList.remove('hidden');
                days[activeDay].classList.add('adsComponent__day--active');
                adCarouselsContainer[activeDay].classList.add('adsComponent__carousel--active');
                bulletsContainer[activeDay].classList.add('glide__bullets--active');
            }
        };

        const getDayFromDate = (dateString: string) => {
            const dateParts = dateString.split('-');
            const day = parseInt(dateParts[2], 10);

            return day.toString();
        };

        adTabs.forEach((tab, index: number) => {
            tab.addEventListener('click', () => {
                activeTab = index;
                index === 0 ? (activeDay = 0) : (activeDay = 5);
                showActiveItems(activeTab, activeDay);
            });
        });

        days.forEach((day, index: number) => {
            day.addEventListener('click', () => {
                activeDay = index;
                showActiveItems(activeTab, activeDay);
            });
        });

        dayNumbers.forEach((day) => {
            const fullDate = day.textContent;
            day.textContent = getDayFromDate(fullDate);
        });

        showActiveItems(activeTab, activeDay);
    }
})